<div class="chart-wrapper" *transloco="let t">
	<svg #svgContainer></svg>

	<div #tooltipOrigin class="tooltip-trigger" [style.left]="tooltipPosition.x" [style.top]="tooltipPosition.y"></div>

	<ng-template
		cdkConnectedOverlay
		[cdkConnectedOverlayOrigin]="tooltipOrigin"
		[cdkConnectedOverlayOpen]="isTooltipVisible"
		[cdkConnectedOverlayPositions]="overlayPositions">
		<div class="gantt-cdk-tooltip">
			@if (selectedSegment) {
				<div class="tooltip-content">
					@if (selectedSegment.isOverlap) {
						<strong>{{ t('billing.chart.conflictOverlap') }}</strong>
						<div class="tooltip-details">
							<span>{{ t('common.since') }}: {{ selectedSegment.from | translocoDate: shortDateOptions }}</span>
							@if (shouldHideToDate(selectedSegment.to)) {
								<span>{{ t('common.to') }}: {{ selectedSegment.to | translocoDate: shortDateOptions }}</span>
							}
						</div>
					}

					<!-- If it's a regular segment -->
					@if (!selectedSegment.isOverlap) {
						@if (selectedSegment.value) {
							<span class="font-semibold">
								{{ selectedSegment.value }}
								@if (selectedSegment.unit) {
									{{ t('enum.' + selectedSegment.unit.toUpperCase()) }}
								} @else if (selectedSegment.additionalDataType === 'tenantPayment') {
									&euro;
								}
							</span>
						}
						<div class="tooltip-details">
							<span>{{ t('common.since') }}: {{ selectedSegment.from | translocoDate: shortDateOptions }}</span>
							@if (shouldHideToDate(selectedSegment.to)) {
								<span>{{ t('common.to') }}: {{ selectedSegment.to | translocoDate: shortDateOptions }}</span>
							}
							@if (selectedSegment.additionalData) {
								@for (item of Object.keys(selectedSegment.additionalData); track item) {
									@if (
										['description', 'periodicity', 'type'].includes(item.toLowerCase()) &&
										selectedSegment.additionalData[item] !== selectedSegment.value
									) {
										<span>
											{{ t('billing.' + item) }}:
											@if (item === 'type') {
												@let translation = t(selectedSegment.additionalDataType + 'Type.' + selectedSegment.additionalData[item]);
												<!-- check if translation was found -->
												@if (!translation.includes('Type.' + selectedSegment.additionalData[item])) {
													{{ translation }}
												} @else {
													{{ t('billing.ordinaryAllocationType.' + selectedSegment.additionalData[item]) }}
												}
											} @else if (item === 'periodicity') {
												{{ t('enum.' + selectedSegment.additionalData[item]) }}
											} @else {
												{{ selectedSegment.additionalData[item] }}
											}
										</span>
									}
								}
							}
						</div>
					}
				</div>
			}
		</div>
	</ng-template>
</div>
